export const TypeEnum = {
    ONLINE: "Online",
    OFFLINE: "Offline",
  };
  